import React, { useState, useEffect } from 'react';
import request from '../../../services/Request';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import CreatePromo from './createPromo';
import Button from '@mui/material/Button';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import QrCodeIcon from '@mui/icons-material/QrCode';
import Swal from 'sweetalert2';
import QRpage from './QRpage';
import { userLimits } from '../uitls/userLimits';
import { CloudDownload } from '@mui/icons-material';
import { ExportToCsv } from 'export-to-csv';
import { UserContext } from '../../contexts/userContext';
import { useContext } from 'react';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import { Box, Chip, alpha, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AddIcon from '@mui/icons-material/Add';

const getPromoURL = `/promos/`;
const getGroupsURL = `/groupsAndMachinesForReport/`;

export default function Promo(props) {
  const theme = useTheme();
  const { userEmail } = useContext(UserContext);
  const { showAdmin, id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Promotions',
    'edit_promo'
  );
  const [update, setUpdate] = useState('false');
  const [show, setShow] = useState(false);
  const [showQ, setShowQ] = useState(false);
  const [buttonTitle, setButtonTitle] = useState('Show Expired Promos');
  const [reflesh, setreflesh] = useState(false);
  const [promo, setPromo] = useState([]);
  const [expire, setExpire] = useState([]);
  const [active, setActive] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [machine, setMachine] = useState([]);
  const [group, setGroup] = useState([]);

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_promo') ? localStorage.getItem('table_view_promo') : 10
  );

  useEffect(() => {
    localStorage.setItem('table_view_promo', pagination);
  }, [pagination]);

  const [qrcode, setQrcode] = useState('');
  const downloadCSV = () => {
    const sample = ['ABCD1234', '4321DCBA'];
    const csvJson = sample.map((e) => {
      return {
        code: e,
      };
    });
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      useTextFile: false,
      filename: 'Sample CSV',
      useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(csvJson);
  };

  useEffect(() => {
    let isCancelled = false;
    // getMyMachines
    setLoading(false);

    async function getGroups() {
      await request({
        method: 'get',
        url: getGroupsURL + userEmail,
      }).then((res) => {
        res.data.machines.forEach((element) => {
          element.product?.forEach((e) => {
            if (e?.id) {
              e.id.name = e?.id?.name?.en;
            }
          });
        });
        if (!isCancelled) {
          console.log('machines', res.data.machines);
          setMachine(res.data.machines);
          setGroup(res.data.groups);
          const gp = res.data.groups.map((e) => e._id);
          const mc = res.data.machines.map((e) => e._id);
          getMyGroups(gp, mc);
        }
      });
    }
    getGroups();

    async function getMyGroups(gp, mc) {
      console.log('gp', gp);
      await request({
        method: 'post',
        url: !props.match.params.group && superAdmin ? getPromoURL : 'promosByEmail',
        data: {
          id: id,
          userEmail: userEmail,
          showAdmin: showAdmin,
          group: gp,
          machine: mc,
        },
      }).then((res) => {
        if (!isCancelled) {
          console.log('res.', res.data);
          res.data.forEach((e) => {
            e?.product?.forEach((a) => {
              a.name = a.name.en;
            });
            e?.category?.forEach((a) => {
              a.name = a.name.en;
            });
          });
          const today = new Date();
          const activePromo = res.data.filter((e) => new Date(e.endDate) > today);
          const expirePromo = res.data.filter((e) => new Date(e.endDate) < today);
          setPromo(buttonTitle === 'Show Expired Promos' ? activePromo : expirePromo);
          setActive(activePromo);
          setExpire(expirePromo);
          setLoading(true);
        }
      });
    }

    return () => {
      isCancelled = true;
    };
  }, [reflesh, buttonTitle]);

  const deleteGroup = async (id) => {
    await request({
      method: 'delete',
      url: getPromoURL + id,
    }).then();
    reflesh ? setreflesh(false) : setreflesh(true);
  };

  const columns = [
    {
      title: 'Desc',
      field: 'title',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
          {rowData.title}
        </Typography>
      ),
    },
    {
      title: 'Code',
      field: 'code',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) => {
        const code = rowData.promoType === 'oneTime' && rowData.isOne ? rowData.originCode[0] : rowData.code;
        return (
          <Chip
            label={code}
            size="small"
            sx={{
              fontWeight: 600,
              fontFamily: 'monospace',
              backgroundColor: alpha(theme.palette.secondary.main, 0.12),
              color: theme.palette.secondary.dark,
              border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
            }}
          />
        );
      },
    },
    {
      title: 'Promo Type',
      field: 'promoType',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) => {
        const string = rowData.promoType;
        const displayText = string?.length > 1 ? string.charAt(0).toUpperCase() + string.slice(1) : '';
        return (
          <Chip
            label={displayText}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(theme.palette.info.main, 0.12),
              color: theme.palette.info.dark,
              border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
            }}
          />
        );
      },
    },
    {
      title: 'Amount',
      field: 'amount',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) => {
        const displayAmount = rowData.percentage ? `${(rowData.amount * 100).toFixed(2)}%` : `$${rowData.amount}`;
        return (
          <Chip
            label={displayAmount}
            sx={{
              fontWeight: 700,
              backgroundColor: alpha(theme.palette.success.main, 0.12),
              color: theme.palette.success.dark,
              border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            }}
          />
        );
      },
    },
    {
      title: 'Start Date',
      field: 'startDate',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
          {new Date(rowData.startDate).toISOString().replace('T', ' ').substr(0, 19)}
        </Typography>
      ),
    },
    {
      title: 'End Date',
      field: 'endDate',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
          {new Date(rowData.endDate).toISOString().replace('T', ' ').substr(0, 19)}
        </Typography>
      ),
    },
    {
      title: 'Product/Category',
      cellStyle: {
        padding: '8px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
      },
      headerStyle: {
        textAlign: 'center',
      },
      render: (rowData) =>
        rowData.cateOrProd === 'All Products' ? (
          `All Products`
        ) : rowData.cateOrProd === 'cate' ? (
          rowData.category?.length > 1 ? (
            <Button
              variant="contained"
              style={{ fontSize: '0.7rem', minHeight: '50px' }}
              onClick={() => {
                let html = '<br/>';
                rowData.category.map((e) => {
                  html += `<p>${e.name}</p>`;
                });
                Swal.fire({
                  html: html,
                  showCloseButton: true,
                  showConfirmButton: false,
                });
              }}
            >
              Show Categoryies
            </Button>
          ) : rowData.category[0] ? (
            `Category: ` + rowData?.category[0].name
          ) : (
            `Category deleted`
          )
        ) : rowData.cateOrProd === 'prod' ? (
          rowData.product.length > 1 ? (
            <Button
              variant="contained"
              style={{ fontSize: '0.7rem', minHeight: '50px' }}
              onClick={() => {
                let html = '<br/>';
                rowData.product.map((e) => {
                  html += `<p>${e.name}</p>`;
                });
                Swal.fire({
                  html: html,
                  showCloseButton: true,
                  showConfirmButton: false,
                });
              }}
            >
              Show Products
            </Button>
          ) : rowData.product?.length > 0 ? (
            `Product: ` + rowData.product[0].name
          ) : (
            'Product deleted'
          )
        ) : null,
    },
    {
      title: 'Machine / Group',
      field: 'machine',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) =>
        rowData.machine.all
          ? `All Machines`
          : rowData.machine.group
          ? rowData.machine.group.name +
            ' (' +
            rowData.machine.group.machineID.map((a) => a.name) +
            ') '
          : rowData.machine.id
          ? rowData.machine.id.name
          : '',
    },
    {
      title: 'Is Active',
      field: 'productsToBuy',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) => {
        const isActive =
          rowData.active === true &&
          new Date(rowData.endDate) > new Date() &&
          rowData?.oneTimeCode?.length > 0;
        const color = isActive ? theme.palette.success.main : theme.palette.error.main;
        const label = isActive ? 'Active' : 'Inactive';
        return (
          <Chip
            icon={<StopRoundedIcon sx={{ fontSize: 14, color: `${color} !important` }} />}
            label={label}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(color, 0.12),
              color: theme.palette.text.primary,
              border: `1.5px solid ${alpha(color, 0.3)}`,
              '& .MuiChip-icon': {
                color,
              },
            }}
          />
        );
      },
    },
    {
      title: 'Created By',
      field: 'created_by',
      cellStyle: { padding: '8px', whiteSpace: 'nowrap' },
      render: (rowData) =>
        rowData?.created_by?.name ? (
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {rowData?.created_by?.name}
            </Typography>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
              {rowData?.created_by?.email}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">-</Typography>
        ),
    },
  ];
  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      {/* Header Section */}
      <ModernPageHeader
        title={tableTitle || 'Promotions'}
        subtitle="Manage promotional codes and discounts"
        icon={LocalOfferIcon}
        buttons={[
          {
            text: buttonTitle,
            icon: buttonTitle === 'Show Expired Promos' ? AddIcon : LocalOfferIcon,
            variant: 'outlined',
            onClick: () => {
              setButtonTitle(
                buttonTitle === 'Show Expired Promos' ? 'Show Active Promos' : 'Show Expired Promos'
              );
              setPromo(buttonTitle === 'Show Expired Promos' ? expire : active);
            },
          },
          access && {
            text: 'Create Promotion',
            icon: AddIcon,
            variant: 'contained',
            onClick: () => {
              setUpdate('false');
              setData(null);
              setShow(true);
              reflesh ? setreflesh(false) : setreflesh(true);
            },
          },
          {
            text: 'Download Sample CSV',
            icon: CloudDownload,
            variant: 'outlined',
            color: 'info',
            onClick: () => {
              downloadCSV();
            },
          },
        ].filter(Boolean)}
      />

      {/* Modern Table */}
      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={promo}
          actions={[
            {
              icon: QrCodeIcon,
              tooltip: 'Generate QR Code',
              onClick: (event, rowData) => {
                if (
                  rowData.promoType === 'oneTime' &&
                  rowData.isOne &&
                  rowData.originCode.length > 0
                ) {
                  setQrcode(rowData.originCode[0]);
                  setShowQ(true);
                } else {
                  setShowQ(true);
                  setQrcode(rowData.code);
                }
              },
            },
            () =>
              access && {
                icon: 'edit',
                tooltip: 'Edit Promo',
                onClick: (event, rowData) => {
                  setUpdate('true');
                  setData(rowData);
                  setShow(true);
                  reflesh ? setreflesh(false) : setreflesh(true);
                },
              },
          ]}
          editable={
            access && {
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(() => {
                    deleteGroup(oldData._id);
                    Swal.fire({
                      text: `The promotion has been successfully deleted: ${oldData.title}`,
                      icon: 'success',
                    });
                    resolve();
                  }, 1000);
                }),
            }
          }
        options={{
          actionsColumnIndex: -1,
          pageSize: parseInt(pagination),
          pageSizeOptions: [10, 20, 50, 100],
        }}
        />

        {/* Back Button */}
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>

        {/* Modals */}
        <CreatePromo
        group={group}
        machine={machine}
        showAdmin={showAdmin}
        userEmail={userEmail}
        id={id}
        reflesh={+reflesh}
        setreflesh={setreflesh}
        update={update}
        show={show}
        data={data}
        setData={setData}
        onHide={() => setShow(false)}
      />
      <QRpage show={showQ} qrcode={qrcode} onHide={() => setShowQ(false)} />
    </Box>
    </ModernPageContainer>
  );
}
